import React, { useState, useEffect } from 'react';
import { Form, Button, Select, InputNumber, Slider, Upload, Input, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { toFormData } from '../../util/FormData';
import BannerTypeService from '../../services/BannerTypeService';
import BannerLocationService from '../../services/BannerLocationService';
const layout = {
	labelCol: {
		span: 4,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 4,
		span: 16,
	},
};
const uploadButton = (
	<div>
		<PlusOutlined />
		<div style={{ marginTop: 8 }}>Upload</div>
	</div>
);

const BannerPostForm = ({ addBanner }) => {
	const [filelist, setFileList] = useState([]);
	const [imageList, setImageList] = useState([]);
	const [bannerTypes, setBannerTypes] = useState();
	const [bannerLocations, setBannerLocations] = useState();

	useEffect(() => {
		if (filelist.length) {
			const file = filelist[filelist.length - 1].originFileObj;
			file.thumbUrl = URL.createObjectURL(file);
			const list = imageList;
			list.push(file);
			setImageList(list);
		}
	}, [filelist]);

	useEffect(() => {
		BannerTypeService.getBannerType()
			.then((data) => {
				setBannerTypes(data.data);
			})
			.catch((err) => message.error('failed'));

		BannerLocationService.getBannerLocation()
			.then((data) => {
				setBannerLocations(data.data);
			})
			.catch(() => message.error('Banner Failed'));
	}, []);

	const onFinish = async (values) => {
		values.image = imageList[0];
		const data = toFormData(values);
		await addBanner(data);
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="adBannerPostForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Upload Image" name="image">
				<Upload
					accept=".jpg,.png,.jpeg"
					listType="picture-card"
					onChange={handleChange}
					fileList={filelist}
					beforeUpload={() => false}
					maxCount={1}
				>
					{uploadButton}
				</Upload>
			</Form.Item>
			<Form.Item label="Company Name" name={['name']} rules={InputRules.name}>
				<Input placeholder="Enter Company Name" />
			</Form.Item>
			<Form.Item label="Link" name={['link']}>
				<Input placeholder="Enter Link" />
			</Form.Item>
			<Form.Item label="Banner Type" name={['bannerType']} rules={InputRules.required('Please select Banner Type')}>
				<Select showSearch allowClear={true} placeholder="Select Banner Type">
					{bannerTypes?.map((data, index) => (
						<Select.Option key={index} value={data.name}>
							{data.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item label="Banner Location" name={['location']} rules={InputRules.required('Please select location')}>
				<Select showSearch allowClear={true} placeholder="Select Ad Banner location" mode="tags">
					{bannerLocations?.map((data, index) => (
						<Select.Option key={index} value={data.name}>
							{data.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item label="Type" name={['type']} rules={InputRules.required('Please select Type')}>
				<Select showSearch allowClear={true} placeholder="Select Type">
					<Select.Option value="landscape">Landscape</Select.Option>
					<Select.Option value="portrait">Portrait</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item label="Banner Priority" name={['priority']}>
				<InputNumber placeholder="Enter Banner Priority" />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Add Banner
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	addBanner: (body) => dispatch(Actions.addBanner(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BannerPostForm);
